"use client";

import { Alert, Button, cn, Table, Typography } from "@kyan/ui";

import { ComboTradeButton } from "./components/ComboTradeButton/ComboTradeButton";
import { usePricesTableController } from "./PricesTable.controller";

export const PricesTable: React.FC = () => {
  const { columns, comboPrices, shouldShowAlert, alertProps, resetComboState } =
    usePricesTableController();

  return (
    <div className="mt-10 grid">
      <Typography grotesk element="h3">
        Orderbook prices
      </Typography>

      <Table
        columns={columns}
        data={comboPrices}
        classes={{
          table: "border border-divider rounded-sm mt-3",
          thead: "border-b border-divider h-10",
          row: "first:border-t-0 min-h-12.5",
          cellClassName: "py-2",
        }}
      />

      <div
        className={cn("mt-2 flex items-center justify-end gap-2", {
          "mt-4 gap-4": !shouldShowAlert,
        })}
      >
        {shouldShowAlert && (
          <Alert
            className="min-w-128"
            title={alertProps.title}
            variant={alertProps.variant}
            description={alertProps.description}
            iconProps={{
              className: "ml-2",
            }}
            actionProps={{
              children: "Edit strategy",
              onClick: resetComboState,
            }}
          />
        )}
        {!shouldShowAlert && (
          <Button
            size="lg"
            variant="secondary"
            className="w-37.5 text-[15px]"
            onClick={resetComboState}
          >
            Edit strategy
          </Button>
        )}

        <ComboTradeButton />
      </div>
    </div>
  );
};
